import { Extensions, registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { ShowCandidateContribution } from './showCandidate.js';
import { TunnelFactoryContribution } from './tunnelFactory.js';
import { RemoteAgentConnectionStatusListener, RemoteMarkers } from './remote.js';
import { RemoteStatusIndicator } from './remoteIndicator.js';
import { ForwardedPortsView, PortRestore, AutomaticPortForwarding } from 'vscode/vscode/vs/workbench/contrib/remote/browser/remoteExplorer';
import { InitialRemoteConnectionHealthContribution } from './remoteConnectionHealth.js';

const workbenchContributionsRegistry = ( Registry.as(Extensions.Workbench));
registerWorkbenchContribution2(ShowCandidateContribution.ID, ShowCandidateContribution, 2 );
registerWorkbenchContribution2(TunnelFactoryContribution.ID, TunnelFactoryContribution, 2 );
workbenchContributionsRegistry.registerWorkbenchContribution(RemoteAgentConnectionStatusListener, 4 );
registerWorkbenchContribution2(RemoteStatusIndicator.ID, RemoteStatusIndicator, 1 );
workbenchContributionsRegistry.registerWorkbenchContribution(ForwardedPortsView, 3 );
workbenchContributionsRegistry.registerWorkbenchContribution(PortRestore, 4 );
workbenchContributionsRegistry.registerWorkbenchContribution(AutomaticPortForwarding, 4 );
workbenchContributionsRegistry.registerWorkbenchContribution(RemoteMarkers, 4 );
workbenchContributionsRegistry.registerWorkbenchContribution(InitialRemoteConnectionHealthContribution, 3 );
